import React from 'react';
import RequiredTag from 'shared/components/forms/RequiredTag';
import { TransformAddButton } from './TransformControls';
import { LockedChip } from './SlotParts';
import { SLOT_LABEL } from './styles';

function LockedFieldSlot({
  label,
  expression,
  required,
  readOnly,
}: {
  label: string;
  expression: string;
  required?: boolean;
  readOnly: boolean;
}) {
  return (
    <div className="mb-4">
      <span className={SLOT_LABEL}>
        {label}
        {required && <RequiredTag size="xs" />}
      </span>
      <LockedChip
        expression={expression}
        // Disabled on purpose: its tooltip explains the field is edited in
        // Code mode.
        wand={
          readOnly ? undefined : (
            <TransformAddButton onAdd={() => {}} disabled />
          )
        }
      />
    </div>
  );
}

export default LockedFieldSlot;
